import React, { useEffect } from 'react';
import { onHydrationFinished } from '~/utils/onHydrationFinished';
import { Page } from './components/Page';
import { Providers } from './components/Providers';
import { type EatAppProps } from './types/EatAppProps';

const EatApp = (props: EatAppProps) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(onHydrationFinished(false), []);

  return (
    <Providers {...props}>
      <Page />
    </Providers>
  );
};

export default EatApp;
